//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.service('FanreelService', [
    '$http',
    '$log',
    '$q',
    'ExperimentsService',
    'PromiseService',
    'UrlUtils',
    '$window',
    function(
            $http,
            $log,
            $q,
            ExperimentsService,
            PromiseService,
            UrlUtils,
            $window,
        ) {
            // This state is used to auto-rotate between N rightsRequestText options as the user approves items.
      let rightsOptions = [];
      let rightsOptionsIndex = 0;

            // Reels Metadata cached because we use this at many of the component layers on the fanreel moderation page.
      const reelsMetadata = {};

      let reelsAsyncResponseCache;
      let reelsAsyncCacheParams;

            // ModerationStatus Enum
      this.MODERATION_STATUS_PENDING = 'unmoderated';
      this.MODERATION_STATUS_APPROVED = 'approved';
      this.MODERATION_STATUS_APPROVED_RIGHTS_NEEDED = 'rights_needed';
      this.MODERATION_STATUS_REJECTED = 'rejected';
      this.MODERATION_STATUS_RIGHTS_REQUESTED = 'rights_pending';
      this.MODERATION_STATUS_RIGHTS_REJECTED = 'rights_rejected';
      this.MODERATION_STATUS_PENDING_SPAM = 'unmoderated_spam';

            // ReelSource Enum
      this.REEL_SOURCE_DESKTOP = 'desktop';
      this.REEL_SOURCE_FACEBOOK = 'facebook';
      this.REEL_SOURCE_PINTEREST = 'pinterest';
      this.REEL_SOURCE_TUMBLR = 'tumblr';
      this.REEL_SOURCE_TWITTER = 'twitter';

      this.getReelsAsync = function(params) {
        return PromiseService.processHttpResponse($http.get('/api/v2/reels', { params }));
      };

      this.getReelsAsyncCached = function(params) {
        if (reelsAsyncResponseCache && !angular.equals(reelsAsyncCacheParams, params)) {
          $log.error(
                        `Invalidated fanreel response cache with new params ${JSON.stringify(params)} and old params ${JSON.stringify(reelsAsyncCacheParams)}`,
                    );
          reelsAsyncResponseCache = undefined;
        }

        if (!reelsAsyncResponseCache) {
          reelsAsyncCacheParams = angular.copy(params);
          reelsAsyncResponseCache = this.getReelsAsync(params);
        }

        return reelsAsyncResponseCache;
      };

      this.getReelMetadataAsync = function(reelId) {
        if (!reelsMetadata[reelId]) {
          reelsMetadata[reelId] = PromiseService.processHttpResponse($http.get(`/api/v2/reels/${reelId}`));
        }

        return reelsMetadata[reelId];
      };

      this.addItemAsync = function(reelId, params) {
        return this.approveItemAsync(reelId, params);
      };

            // Approve and save.
      this.approveItemAsync = function(reelId, item) {
        const activeExperiments = ExperimentsService.getActiveExperiments();
        return PromiseService.processHttpResponse($http.put(`/api/v2/reels/${reelId}/items/${item.cuid}/status`, {
          moderationStatus: this.MODERATION_STATUS_APPROVED,
          rightsRequestText: item.rightsRequestText,
          approvalPhrase: item.approvalPhrase,
          bypassRightsRequest: item.bypassRightsRequest,
          deetsId: item.deetsId,
          cuid: item.cuid,
          activeExperiments,
        }));
      };

            // Approve and save without rights
      this.approveItemWithoutRightsAsync = function(reelId, item) {
        const activeExperiments = ExperimentsService.getActiveExperiments();
        return PromiseService.processHttpResponse($http.put(`/api/v2/reels/${reelId}/items/${item.cuid}/status`, {
          moderationStatus: this.MODERATION_STATUS_APPROVED,
          bypassRightsRequest: item.bypassRightsRequest,
          deetsId: item.deetsId,
          cuid: item.cuid,
          dontSkipOrRequestRights: true,
          activeExperiments,
        }));
      };

            // Reject and save.
      this.rejectItemAsync = function(reelId, item, rejectionCode) {
        const activeExperiments = ExperimentsService.getActiveExperiments();
        return PromiseService.processHttpResponse($http.put(`/api/v2/reels/${reelId}/items/${item.cuid}/status`, {
          moderationStatus: this.MODERATION_STATUS_REJECTED,
          deetsId: item.deetsId,
          cuid: item.cuid,
          fileId: item.photo ? item.photo.fileId : null,
          networkUserId: item.user ? item.user.networkUserId : null,
          activeExperiments,
          rejectionCode,
        }));
      };

      this.getModerationItemsAsync = function(params) {
        const debugParams = UrlUtils.getUrlParams($window.location.search);
        const httpParams = {};

        if (_.has(params, 'offset')) {
          httpParams.offset = params.offset;
        }

        if (_.has(params, 'limit')) {
          httpParams.limit = params.limit;
        }

        if (_.has(params, 'status')) {
          httpParams.status = params.status;
        }

        if (_.has(params, 'sort')) {
          httpParams.sort = params.sort;
        }

        if (_.has(params, 'ingestFilter')) {
          httpParams.ingestFilter = params.ingestFilter;
        }

        if (_.has(params, 'network')) {
          httpParams.network = params.network;
        }

        if (_.has(params, 'searchText')) {
          httpParams.searchText = params.searchText;
        }

        if (_.has(params, 'shareCreatorFilter')) {
          httpParams.shareCreatorFilter = params.shareCreatorFilter;
        }

        if (_.has(params, 'dateRangeFilter')) {
          httpParams.dateRangeFilter = params.dateRangeFilter;
        }

        if (debugParams.debug) {
          httpParams.debug = 'true';
          httpParams.imageThresh = debugParams.imageThresh;
          httpParams.captionThresh = debugParams.captionThresh;
          httpParams.thresh = debugParams.thresh;
        }

        if (httpParams.sort === 'VisualScore') {
          ExperimentsService.setExperimentIsActive('FanreelModerationSortVisualScore', true);
        } else {
          ExperimentsService.setExperimentIsActive('FanreelModerationSortVisualScore', false);
        }

        return PromiseService.processHttpResponse($http.get(`/api/v2/reels/${params.reelId}/items`, { params: httpParams }));
      };

      this.getCustomFiltersAsync = function(reelId) {
        return PromiseService.processHttpResponse($http.get(`/api/v2/reels/${reelId}/custom-filters`));
      };

      this.getProductTypeaheadResultsAsync = function(reelId, query) {
        return PromiseService.processHttpResponse($http.get(`/api/v2/reels/${reelId}/products`, { params: { search: query } }));
      };

      this.updateFanreelPhotoAsync = function(reelId, item, updatedImageUrl) {
        return PromiseService.processHttpResponse($http.put(`/api/universal-image-actions/items/${item.cuid}/alt-image`, {
          updatedImageUrl,
        }));
      };

      this.revertFanreelPhotoAsync = function(reelId, item) {
        return PromiseService.processHttpResponse($http.put(`/api/universal-image-actions/items/${item.cuid}/alt-image`, {
        }));
      };

            //
            // Fanreel Moderation global state helpers
            //

      this.initRightsOptions = function(rightsOptionsData) {
        if (rightsOptionsData && rightsOptionsData.length) {
          rightsOptions = rightsOptionsData[0].data;

                    // Start at a random index every time initialized (at page load).
          rightsOptionsIndex = Math.floor(Math.random() * rightsOptions.length);
        }
      };

      this.nextRightsOption = function() {
        rightsOptionsIndex++;

                // Check wrap around.
        if (rightsOptionsIndex >= rightsOptions.length) {
          rightsOptionsIndex = 0;
        }

        return rightsOptions[rightsOptionsIndex];
      };

            /* Displays debug information in UI if set */
      this.isDebugMode = function() {
        const debugParam = UrlUtils.getUrlParams($window.location.search).debug || 'false';
        return debugParam.toLowerCase() === 'true';
      };

            //
            // Fanreel and Canvas Summary Export URLs
            //

      this.getReelsSummaryExportUrl = function(params) {
        const paramString = $.param(params);
        return `/api/v2/reels.zip${paramString ? `?${paramString}` : ''}`;
      };

            //
            // Canvas endpoints
            //

      this.getCanvasesAsync = function(params) {
        return PromiseService.processHttpResponse($http.get('/api/v2/canvases', { params }));
      };

      this.getCanvasOptionsAsync = function() {
        return PromiseService.processHttpResponse($http.get('/api/v2/canvases/options'));
      };

      this.createCanvasAsync = function(params) {
        return PromiseService.processHttpResponse($http.post('/api/v2/canvases', params));
      };

      this.deleteCanvasAsync = function(reelId) {
        return PromiseService.processHttpResponse($http.delete(`/api/v2/canvases/${reelId}`));
      };

            //
            // Other
            //
      this.getFocusedItem = function(reelId, params) {
        return PromiseService.processHttpResponse($http.get(`/api/v2/reels/${reelId}/focused-item`, { params }));
      };

      this.getIsItemInReel = function(reelId, cuid) {
        return PromiseService.processHttpResponse($http.get(`/api/v2/reels/${reelId}/is-item-in-reel/${cuid}`))
                    .then(res => res.isApproved);
      };

      this.getModerationUrl = function(reelId) {
        return `/fanreel/moderation/${reelId}`;
      };
    },
  ]);
})();
